module.exports = __webpack_public_path__ + "static/media/cozy9101.ef59ea71.jpg";